import React from 'react';
import {
  makeStyles,
  IconButton,
  Box,
  Grid,
  Divider,
  // InputAdornment,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withTranslation } from 'config/i18n';
import Typography500 from 'common/components/Typography500';
import Image from 'next/image';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: theme.typography.pxToRem(24),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  imgContainerGrid: {
    position: 'relative',
  },
  imgContainer: {
    height: theme.spacing(15),
    overflow: 'hidden',
    zIndex: -1,
  },
}));

const MainWidgetDialogTitle = (props) => {
  const classes = useStyles();
  const {
    onClose, bikeName, image, t,
  } = props;
  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={6} lg={6}>
          <Box>
            <Typography500 variant="h3" component="h4" className={classes.dialogTitle}>
              {t('fe_es_common_main_widget:start_your_adventure')}
            </Typography500>
            <Box py={1}>
              <Divider light />
            </Box>
            <Typography500 variant="subtitle1" component="p">
              {bikeName}
            </Typography500>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={6} className={classes.imgContainerGrid}>
          <Box className={classes.imgContainer}>
            <Image
              src={image.src || '/imgs/logo.jpg'}
              alt={image.alt}
              layout="fill"
              objectFit="contain"
              unoptimized
              width="100%"
            />
          </Box>
        </Grid>
      </Grid>

      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};
export default withTranslation(['fe_es_common_main_widget'])(MainWidgetDialogTitle);
